import React from 'react'
import { getMessage } from '../../../utils/index'
import { Card } from 'primereact/card'

import './ContaCorrenteForm.scss'
import LtsInputText from '../../../components/lottus/lts-input-text'
import utils from '../../../utils'
import _ from 'lodash'
import LtsLookupConfiguracaoBoleto from '../../../components/lottus/lts-lookup-configuracao-boleto'
import { Checkbox } from 'primereact/checkbox'
import LtsDropdownUnidade from '../../../components/lottus/lts-dropdown-unidade'

export const ContaCorrenteForm = (props) => {
  const record = props.record
  const messages = props.messages

  return (
    <div className="p-grid p-fluid">
      <div className="p-col-12">
        <Card title={`${getMessage(messages, 'contacorrente.label.contacorrente')} ${record.oid || ''}`}>
          <div className="p-grid form-group">
            <div className="p-col-12 p-sm-8 p-md-6 p-lg-4 p-xl-4">
              <LtsDropdownUnidade
                name={'unidade'}
                label={getMessage(messages, 'contacorrente.label.unidade') || 'Unidade'}
                value={props.record.unidade}
                onChange={(e) => props.onChangeField('unidade', e)}
                showOptionAll={false}
                disabled={props.disableUnit}
                options={props.unidades}
              />
            </div>
          </div>
          <div className="p-grid form-group">
            <div className="p-col-12 p-sm-8 p-md-6 p-lg-4 p-xl-4">
              <LtsInputText
                value={record.descricao}
                onChange={(e) => props.onChangeDescricao(e)}
                name="descricao"
                autoFocus={true}
                maxLength={255}
                label={getMessage(messages, 'contacorrente.label.descricao')}
              />
            </div>
          </div>

          <div className="p-grid form-group">
            <div className="p-col-6 p-sm-8 p-md-6 p-lg-4 p-xl-4">
              <LtsLookupConfiguracaoBoleto
                label={utils.getMessage(messages, 'contacorrente.label.configuracaoboleto')}
                value={_.get(record, 'configuracaoBoleto.value', '')}
                oidRecord={_.get(record, 'configuracaoBoleto.id', '')}
                history={props.history}
                onChange={(e) => props.setConfiguracaoBoleto(e)}
              />
            </div>
          </div>

          <div className="p-grid form-group">
            <div className="p-col-6 p-sm-8 p-md-6 p-lg-4 p-xl-2">
              <LtsInputText
                value={record.banco}
                onChange={(e) => props.onChangeField('banco', e)}
                name="banco"
                maxLength={50}
                label={getMessage(messages, 'contacorrente.label.banco')}
              />
            </div>
          </div>

          <div className="p-grid form-group">
            <div className="p-col-6 p-sm-8 p-md-6 p-lg-4 p-xl-2">
              <LtsInputText
                value={record.agencia}
                onChange={(e) => props.onChangeField('agencia', e)}
                name="agencia"
                maxLength={50}
                label={getMessage(messages, 'contacorrente.label.agencia')}
              />
            </div>
          </div>

          <div className="p-grid form-group">
            <div className="p-col-6 p-sm-8 p-md-6 p-lg-4 p-xl-2">
              <LtsInputText
                value={record.numero}
                onChange={(e) => props.onChangeField('numero', e)}
                name="numero"
                maxLength={50}
                label={getMessage(messages, 'contacorrente.label.numero')}
              />
            </div>
          </div>

          <div className="p-grid form-group">
            <div className="p-col-6 p-sm-8 p-md-6 p-lg-4 p-xl-2">
              <LtsInputText
                value={record.codigoConvenio}
                onChange={(e) => props.onChangeField('codigoConvenio', e)}
                name="codigoConvenio"
                maxLength={50}
                label={getMessage(messages, 'contacorrente.label.convenio')}
              />
            </div>
          </div>

          <div className="p-grid form-group">
            <div className="p-col-6 p-sm-8 p-md-6 p-lg-4 p-xl-2">
              <Checkbox
                checked={record.ativo}
                onChange={(e) => props.onChangeField('ativo', e)}
                name="ativo"
                style={{ marginRight: '5px' }}
              />
              <label htmlFor="chkativo" className="label">
                {getMessage(messages, 'contacorrente.label.ativo')}
              </label>
            </div>
          </div>
        </Card>
      </div>
    </div>
  )
}
